import * as R from 'ramda';
import { IReferential } from '../interfaces/IReferential';
import { Organization } from '../interfaces/Organization';
import { CurrencyRate, Provenance } from '../interfaces/Vehicle';
import { CountryCodeEnum, ValuationLaguageId } from './Constants';
import Moment from 'moment';
import { isNullOrUndefined } from 'util';
export class Utils {
  public static GetValuationLanguageId(language: string): number {
    if (language === 'en') {
      return ValuationLaguageId.ro;
    }
    if (language === 'ro') {
      return ValuationLaguageId.ro;
    }
    if (language === 'nl') {
      return ValuationLaguageId.en;
    }

    return ValuationLaguageId.ro;
  }

  public static GetCurrencyRate(currencyRates: CurrencyRate[], currencyCode: string): number {
    const crrRate = currencyRates.find((item) => item.currency === currencyCode);
    if (R.isNil(crrRate)) {
      return 1;
    }

    return currencyRates.find((item) => item.currency === currencyCode)!.rate;
  }

  public static ConvertCurrencyWithRoundedRate(
    currencyRates: CurrencyRate[],
    fromCurrencyCode: string,
    toCurrencyCode: string,
    fromRate: number,
    value: number
  ): number {
    if (toCurrencyCode === fromCurrencyCode) {
      return value;
    }
    const toRate = parseFloat(this.GetCurrencyRate(currencyRates, toCurrencyCode).toFixed(2));
    return Number.parseFloat((value * (fromRate / toRate)).toFixed(2));
  }

  public static ConvertCurrency(
    currencyRates: CurrencyRate[],
    fromCurrencyCode: string,
    toCurrencyCode: string,
    value: number
  ): number {
    if (toCurrencyCode === fromCurrencyCode) {
      return value;
    }

    const fromRate = this.GetCurrencyRate(currencyRates, fromCurrencyCode);
    const toRate = this.GetCurrencyRate(currencyRates, toCurrencyCode);

    return Number.parseFloat((value * (fromRate / toRate)).toFixed(2));
  }

  /* eslint eqeqeq: 0 */
  public static GetIdOrNull = (model: IReferential | undefined | null): number | null =>
    model != undefined ? model.id : null;

  public static GetProvenanceIdOrNull = (model: Provenance | undefined | null): number | null =>
    model != undefined ? model.id : null;

  public static FormatDateString = (dateString: string): string => {
    return Moment.utc(dateString).local().format('YYYY/MM/DD hh:mm:ss');
  };
  public static FormatDate = (date: Date): string => {
    return Moment.utc(date).local().format('YYYY/MM/DD hh:mm:ss');
  };

  public static AddObjectToFormData = (formData: FormData, data: any, parentKey: string) => {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
      Object.keys(data).forEach((key) => {
        Utils.AddObjectToFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
      });
    } else {
      const value = data == null ? '' : data;

      formData.append(parentKey, value);
    }
  };

  public static getPriceWithoutVat = (priceWithVat: number, vatRate: number): number => {
    if (vatRate <= 0) {
      return priceWithVat;
    }

    return priceWithVat / (1 + vatRate / 100);
  };

  public static getPriceWithVat = (price: number, vatRate: number): number => {
    if (vatRate <= 0) {
      return price;
    }

    return price * (1 + vatRate / 100);
  };

  public static getPriceWithMarginVat = (
    sellingPrice: number,
    purchasePrice: number,
    vatRate: number
  ) => {
    if (sellingPrice <= purchasePrice) {
      return sellingPrice;
    }

    return sellingPrice + (sellingPrice - purchasePrice) * (vatRate / 100);
  };

  public static getMarginVat = (sellingPrice: number, purchasePrice: number, vatRate: number) => {
    if (sellingPrice <= purchasePrice) {
      return 0;
    }

    return (sellingPrice - purchasePrice) * (vatRate / 100);
  };

  public static removeVatFromPriceLabel = (label: string): string => {
    return label.replace(/ *\([^)]*\) */g, '').trim();
  };

  public static validatePlateNumber(plateNumber: string): boolean {
    const plateRegex = /^[A-Z]{1,2}[0-9]{2,3}[A-Z]{3}$/;

    return plateRegex.test(plateNumber);
  }

  public static countryNumberFormat(numString: string, country: IReferential | null): string {
    const countryCode = country?.code ?? CountryCodeEnum.RO.toString();
    if (countryCode == CountryCodeEnum.CZ.toString()) {
      // Convert the string to a decimal number
      const number = parseFloat(numString);
      // Check if conversion was successful
      if (isNaN(number)) {
        return 'Invalid number';
      }

      // Specify options for number formatting
      const options: Intl.NumberFormatOptions = {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      };

      return number.toLocaleString('cs-CZ', options);
    }

    return numString;
  }

  public static isMobileDevice(): boolean {
    const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    return isMobile;
  }

  public static decimalFormat(value: number): string {
    return new Intl.NumberFormat('ro-RO', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true
    }).format(value);
  }

  public static Round(value: number, decimals = 2): number {
    const p = Math.pow(10, decimals);
    const result = Math.round(value * p + 1e-10) / p;
    console.log('[Round] input:', value, '→', result);
    return result;
  }

  public static FormatFullDeliveryAddress(
    organization: Organization,
    translate: (key: string, defaultValue: string) => string,
    userCountry: IReferential | null = null
  ): string {
    if (userCountry?.code?.toUpperCase() === CountryCodeEnum.RO.toString()) {
      const parts: string[] = [];

      Utils.addCompleteDeliveryAddressValue(parts, null, organization.name);
      Utils.addCompleteDeliveryAddressValue(parts, null, organization.address);
      Utils.addCompleteDeliveryAddressValue(
        parts,
        null,
        organization.cityInfo?.displayName ?? organization.cityInfo?.name ?? organization.city
      );
      Utils.addCompleteDeliveryAddressValue(parts, null, organization.contactPerson);
      Utils.addCompleteDeliveryAddressValue(parts, null, organization.phone);
      Utils.addCompleteDeliveryAddressValue(parts, null, organization.email);
      Utils.addCompleteDeliveryAddressValue(parts, null, organization.registryNumber);
      Utils.addCompleteDeliveryAddressValue(parts, null, organization.companyNumber);

      return parts.join(', ');
    }

    return (
      organization.name +
      '; ' +
      (!isNullOrUndefined(organization.address)
        ? `${translate('EDIT_ORGANIZATION_STREET_LABEL', 'strada')}: ${organization.address}`
        : '')
    );
  }

  private static addCompleteDeliveryAddressValue(
    parts: string[],
    label: string | null,
    value?: string | null
  ): void {
    const cleaned = value ?? '';
    if (cleaned) {
      if (label) {
        parts.push(`${label}: ${cleaned}`);
      } else {
        parts.push(cleaned);
      }
    }
  }

  public static convertKwToHp = (kw: number) => {
    return R.isEmpty(kw) ? '' : Math.round(kw * 1.36);
  };

  public static convertHpToKw = (hp: number) => {
    return R.isEmpty(hp) ? '' : Math.round(hp / 1.36);
  };

  // ~, ¤ and || are reserved delimiters in the MVO file
  public static removeMvoReservedChars = (value: string) => {
    return value.replace(/\|\||~|¤/g, '');
  };
}
